"use strict";

function importAll(r) {
    r.keys().forEach(r);
}

window.ready = [];
import 'jquery'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'featherlight'
import 'jquery.loadtemplate'
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';
import "@fancyapps/ui/dist/fancybox.css"
import "@fancyapps/ui/dist/carousel.css"
import 'intl-tel-input/build/css/intlTelInput.css'

require('./js/utils/website.js');
require('./js/utils/common');
require('./css/app.scss');
require("./less/index.less")
require("./js/libs/a2hs.js");
require('./js/libs/socialObj.js');
require('./js/utils/common-form-actions');
window.auth = require('./js/libs/auth').default;
window.logout = require('./js/libs/logout').default;
window.restrictedAuth = require('./js/libs/restrictedAuth').default;
require('./js/utils/community-image');
require('./js/utils/community-view-approval');
require('./js/utils/group-actions');
require('./js/libs/focusable');
require('./js/utils/modal-tab');
window.subscriber = require('./js/utils/subscribe-actions').default;
window.member = require('./js/utils/member-actions').default;
window.payments = require('./js/utils/payment');
window.sendUserTimezone = require('./js/utils/sendUserTimezone').default;
window.updateUserProfile = require('./js/utils/updateUserProfile').default;
window.editCommunity = require('./js/utils/edit-community').default;
require('./js/utils/subscribers-list');
require('./js/utils/trumbowyg');
require('./js/utils/profile');

importAll(require.context("./images", true, /^.*\.(svg|jpeg|jpg|png|ico)$/));
importAll(require.context("bootstrap-datepicker/js/locales", false, /^(?!(kr|kh|rs)\.js)[a-zA-Z]{2}\.js$/));

$(() => {
    require('./js/libs/docready').default(document);
});
